// These methods are used to track components being rendered on the document.
// Needed until we are using react to render the entire document and don't
// rely on backbone or other front end frameworks.
import ReactDOM from 'react-dom';
import React from 'react';
import { register } from './component-registry';

export default (component, props, selector) => {
  ReactDOM.render(
    React.createElement(component, props),
    $(selector)[0]);
  register(selector);
}



// WEBPACK FOOTER //
// ./src/shared/render-react-component.js